// ====- fade in animation
const observeSections = document.querySelectorAll('#vol21style .js-fadeIn');
const observeFrames = document.querySelectorAll('#vol21style .js-drawingFrame');
const options = {
  rootMargin: '-10%',
  threshold: 0
}

const observer = new IntersectionObserver(showlements, options);

observeSections.forEach(observeSection => {
  observer.observe(observeSection);
})
observeFrames.forEach(observeFrame => {
  observer.observe(observeFrame);
})

function showlements(entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-show');
    }
  });
}
